module.exports = __webpack_public_path__ + "static/media/ISO-BV.12a61eeb.jpg";